import { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import ProviderProfile from '../providerProfile/ProviderProfile';
import axios from '../../utils/axiosCompanyProxy';

/**
 * Standalone Provider Profile Page
 * This component creates a standalone page for viewing a provider profile
 * accessible via /provider/:id URL
 */
const StandaloneProviderProfile = () => {
	const { id } = useParams();
	const navigate = useNavigate();
	const [providerData, setProviderData] = useState(null);
	const [loading, setLoading] = useState(true);
	const [error, setError] = useState(null);

	useEffect(() => {
		const fetchProviderData = async () => {
			try {
				setLoading(true);
				const response = await axios.get(`/api/provider/${id}`);

				if (response.data && response.data.provider) {
					// Construct the data object that ProviderProfile expects
					const data = {
						providerID: id,
						providerName:
							response.data.provider.provider_info?.companyname || '',
						provider_package: {
							startDate:
								response.data.provider.provider_package?.startDate || null,
						},
					};
					setProviderData(data);
				} else {
					setError('Provider not found');
				}
			} catch (err) {
				console.error('Error fetching provider data:', err);
				setError('Failed to load provider profile');
			} finally {
				setLoading(false);
			}
		};

		if (id) {
			fetchProviderData();
		} else {
			setError('Invalid provider ID');
			setLoading(false);
		}
	}, [id]);

	const handleBack = () => {
		navigate(-1);
	};

	const handleForward = () => {
		// This can be used for future functionality
		// For now, it's a no-op since standalone profile doesn't need modal navigation
	};

	if (loading) {
		return (
			<div style={{ padding: '2rem', textAlign: 'center' }}>
				<p>Loading provider profile...</p>
			</div>
		);
	}

	if (error) {
		return (
			<div style={{ padding: '2rem', textAlign: 'center' }}>
				<p>{error}</p>
				<button onClick={handleBack}>Go Back</button>
			</div>
		);
	}

	if (!providerData) {
		return (
			<div style={{ padding: '2rem', textAlign: 'center' }}>
				<p>Provider not found</p>
				<button onClick={handleBack}>Go Back</button>
			</div>
		);
	}

	return (
		<ProviderProfile
			data={providerData}
			setOpen={handleBack}
			setOpenForward={handleForward}
		/>
	);
};

export default StandaloneProviderProfile;
